export const formFieldsPerLanguage = (fields, { formFieldRules }) => {
  Object.keys(fields).forEach(fieldKey => {
    const rulePerLanguage = formFieldRules[fieldKey]
    const fieldValue = fields[fieldKey]
    fieldValue.rules = rulePerLanguage || fieldValue.rules
  })
}



// WEBPACK FOOTER //
// ./src/mi-app/language/FormFieldsPerLanguage.js